import React, { useMemo } from 'react';
import { useGetDocumentCategoriesInfinite } from '@area-restrita/api-client/endpoints/document-category/document-category.gen';

import DataTableFacetedFilter, {
  IDataTableFacetedFilterProps,
} from '../DataTable/DataTableFacetedFilter';

type IProps = Omit<IDataTableFacetedFilterProps<any, any>, 'options'>;

const DocumentCategoryFilter = React.forwardRef<HTMLInputElement, IProps>(
  (props, _ref) => {
    const query = useGetDocumentCategoriesInfinite(
      { limit: 100, page: 1 },
      {
        query: {
          queryKeyHashFn: (args) => JSON.stringify(['infinite', ...args]),
          getNextPageParam: (lastPage, _, lastPageParam) =>
            lastPage.data.length > 0 ? lastPageParam + 1 : null,
        },
      },
    );

    const categories = useMemo(
      () =>
        query.data?.pages.flatMap((page) =>
          page.data.map((category) => ({
            label: category.description,
            value: category.id,
          })),
        ) ?? [],
      [query.data],
    );

    return <DataTableFacetedFilter options={categories} {...props} />;
  },
);

export default DocumentCategoryFilter;
